<app-ui-modal #imagePreviewModal [hideHeader]="true" [hideFooter]="true" dialogClass="image-preview-dialog">
    <div class="app-modal-body">
        <button type="button" class="image-preview-close" (click)="imagePreviewModal.hide()" aria-label="Close">&times;</button>
        <img appNftImage [src]="imageSrc" [alt]="imageAlt" class="image-preview-img" data-no-preview>
    </div>
</app-ui-modal>
